import PropTypes from 'prop-types';
import React from 'react';

import './ExamInformation.pcss';
import Paragraph from '@mos-cat/paragraph';

const ExamInformation = ({ exam }) => (
  <Paragraph className="ExamInformation">
    <span>
      Мин. кол-во баллов:{' '}
      {exam.type_is_gve ? exam.minscore || 2 : exam.minscore}
    </span>
    <span>Форма ГИА: {exam.type_name}</span>
    <span>Дата экзамена: {exam.date_formatted}</span>
  </Paragraph>
);

ExamInformation.propTypes = {
  exam: PropTypes.shape({
    prescore: PropTypes.string,
    minscore: PropTypes.string,
    maxscore: PropTypes.string,
    type_is_gve: PropTypes.bool,
    date: PropTypes.string
  }).isRequired
};

export default ExamInformation;
